import React from 'react';
import { EditRubricCategoryCriteriaPreview } from 'apps/sigma2-ui/src/components/rubrics/EditRubricCategoryCriteriaPreview';
import { EditRubricSectionThread } from 'apps/sigma2-ui/src/components/rubrics/EditRubricSectionThread';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { RubricTagPill } from 'apps/sigma2-ui/src/components/rubrics/RubricTagPill';
import cn from 'classnames';
import { RubricTagOverflowPill } from 'apps/sigma2-ui/src/components/rubrics/RubricTagOverflowPill';

export interface RubricPreviewCategoryContentCriteriaProps {
  criteria: string;
  weight: number;
}

export interface RubricPreviewCategoryContentProps {
  label: string;
  tags: string[];
  criteria: RubricPreviewCategoryContentCriteriaProps[];
  maxHeightClassName?: string;
}

export const RubricPreviewCategoryContent: React.FC<
  RubricPreviewCategoryContentProps
> = (props) => {
  const maxTagsToShow = 2;

  return (
    <Spacing size="lg" direction="vertical">
      <Spacing
        size="lg"
        direction="horizontal"
        className="items-center justify-between rounded-2xl bg-gray-100 py-6 px-8"
      >
        <S2Typography
          variant="headline-4-alt"
          textColorVariant="gray-1000"
          translatedContent={props.label}
          dangerouslyOverrideClassNameFn={(cn) => `${cn} flex-wrap`}
        />
        <Spacing size="sm" direction="horizontal" className="flex-wrap">
          {props.tags.slice(0, maxTagsToShow).map((tag) => (
            <RubricTagPill key={tag} name={tag} />
          ))}
          {props.tags.length > maxTagsToShow && (
            <RubricTagOverflowPill
              overflowCount={props.tags.length - maxTagsToShow}
              tags={props.tags}
            />
          )}
        </Spacing>
      </Spacing>
      <div
        className={cn(
          props.maxHeightClassName ?? 'max-h-[52vh]',
          'overflow-y-auto pr-2 flex-1',
        )}
      >
        <EditRubricSectionThread>
          <Spacing size="sm" direction="vertical" className="w-full py-2">
            {props.criteria.map((c, idx) => (
              <EditRubricCategoryCriteriaPreview
                key={idx}
                criteria={c.criteria}
                weight={c.weight}
              />
            ))}
          </Spacing>
        </EditRubricSectionThread>
      </div>
    </Spacing>
  );
};
